import { Button, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import spinnerTitle from 'components/others/spinnerTitle';
import useDocumentGenerate from '../model/useDocumentGenerate';
import type { ProposalEditFormValues } from '../../Proposal/types';
import SolarIcon from 'components/icons/SolarIcon';
import GenerationEmailField from '../../share/GenerationEmailField';

interface DocumentGenerateTabProps {
    objectId?: number | string;
    objectName?: string;
    clientEmail?: string;
    dirProposalId?: number | null;
    formData: ProposalEditFormValues;
    rate: number;
    objectData?: unknown;
    onGenerated?: () => Promise<void> | void;
}

const DocumentGenerateTab = ({
    objectId,
    objectName = '',
    clientEmail = '',
    dirProposalId = null,
    formData,
    rate,
    objectData,
    onGenerated,
}: DocumentGenerateTabProps) => {
    const { t } = useTranslation(['Document', 'common']);
    const {
        sendToClient,
        setSendToClient,
        clientEmail: emailValue,
        setClientEmail,
        generating,
        canGenerate,
        handleGenerate,
    } = useDocumentGenerate({
        objectId,
        objectName,
        clientEmail,
        dirProposalId,
        formData,
        rate,
        objectData,
        onGenerated,
    });

    return (
        <div className="document-generate-tab">
            <div className="form-check form-switch mb-0">
                <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="document-send-to-client"
                    checked={sendToClient}
                    onChange={(e) => setSendToClient(Boolean(e.target.checked))}
                />
                <label className="form-check-label" htmlFor="document-send-to-client">
                    {t('edit.generate.sendToClientLabel')}
                </label>
                <div className="small text-muted">{t('edit.generate.sendToClientHint')}</div>
            </div>

            {sendToClient ? (
                <Form.Group className="mt-3 mb-0">
                    <Form.Label>{t('edit.generate.clientEmailLabel')}</Form.Label>
                    <GenerationEmailField
                        value={emailValue}
                        onChange={setClientEmail}
                        placeholder={t('edit.generate.clientEmailPlaceholder')}
                        disabled={generating}
                    />
                </Form.Group>
            ) : null}

            <div className="mt-4">
                <Button
                    type="button"
                    variant="primary"
                    disabled={generating || !canGenerate}
                    onClick={() => void handleGenerate()}
                >
                    {spinnerTitle(
                        <>
                            <SolarIcon name="file-earmark-arrow-down" className="me-2" />
                            {t('edit.generate.generateButton')}
                        </>,
                        generating,
                        t('edit.generate.generateButtonLoading'),
                    )}
                </Button>
            </div>
        </div>
    );
};

export default DocumentGenerateTab;
